export default __webpack_public_path__ + "images/Transventricular_View.72fa26194aff466f4b94bbde0443d1eb.png";